module.exports = __webpack_public_path__ + "img/big_1_17.7da61928.png";